export const MenuAdmin = [

  {
    menutitle: "DashBoard",
    menucontent: "Ready to use Apps",
    Items: [
      { path: `${process.env.PUBLIC_URL}/admin/dashboard/sales`, icon: "charts", title: "Sales", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/dashboard/tenant`, icon: "charts", title: "Tenant", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/dashboard/traffic`, icon: "charts", title: "Traffic", type: "link" },
    ],
  },
  {
    menutitle: "Analytics",
    menucontent: "Ready to use Apps",
    Items: [

      { path: `${process.env.PUBLIC_URL}/admin/analytics`, icon: "knowledgebase", title: "Analytics", type: "link" },
    ],
  },

  {
    menutitle: "Reports",
    menucontent: "Ready to use Apps",
    Items: [
      {
        title: "Reports",
        icon: "table",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [

          { path: `${process.env.PUBLIC_URL}/admin/report/daywisereport`, icon: "file", title: "Daywise Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/mtdreport`, icon: "file", title: "MTD Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/daywiseconsolidated`, icon: "file", title: "Sales Summary Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/monthwisesales`, icon: "file", title: "Monthwise Sales Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/revenuesharereport`, icon: "file", title: "Revenue Share Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/tradingdensityreport`, icon: "file", title: "Trading Density Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/dailycomprehensiverevenue`, icon: "file", title: "Daily Comprehensive Revenue Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/growthanalysisreport`, icon: "file", title: "Growth Analysis Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/fbsalessummary`, icon: "file", title: "F&B Sales Summary", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/deliverypartnerreport`, icon: "file", title: "Sales Report-Delivery Partners", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/missingdates`, icon: "file", title: "Missing Dates Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/additionalsalessummary`, icon: "file", title: "Additional Sales Summary Reports", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/dynamicreports`, icon: "file", title: "Dynamic Reports", type: "link" },

        ],
      },
      {
        title: "More Reports",
        icon: "table",
        type: "sub",
        badge: "badge badge-light-secondary",
        active: false,
        children: [

          { path: `${process.env.PUBLIC_URL}/admin/report/tenantauditreport`, icon: "file", title: "Audit Detail Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/itemwisereport`, icon: "file", title: "Itemwise Detail Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/invoicewisesalesreport`, icon: "file", title: "Invoicewise Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/hourlysalesreport`, icon: "file", title: "Hourly Sales Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/tenantitemwisesales`, icon: "file", title: "Tenant Itemwise Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/consolidateddaywisereport`, icon: "file", title: "Consolidated Daywise Report", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/timeseriestrendchartreport`, icon: "file", title: "TimeSeries Trend", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/monthlysalestrendreport`, icon: "file", title: "Monthly Sales Trend", type: "link" },
          { path: `${process.env.PUBLIC_URL}/admin/report/daywisesalestrendreport`, icon: "file", title: "Daywise Sales Trend", type: "link" },
        ],
      },
    ]
  },

  {
    menutitle: "Data Grid",
    menucontent: "Ready to use Apps",
    Items: [

      { path: `${process.env.PUBLIC_URL}/admin/datagrid`, icon: "landing-page", title: "Data Grid - Live", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/invoicegrid`, icon: "landing-page", title: "Invoice Grid - Live", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/itemgrid`, icon: "landing-page", title: "Item Grid - Live", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/uatdatagrid`, icon: "landing-page", title: "Data Grid - UAT", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/uatinvoicegrid`, icon: "landing-page", title: "Invoice Grid - UAT", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/uatitemgrid`, icon: "landing-page", title: "Item Grid - UAT", type: "link" },
    ],
  },
  
  {
    menutitle: "Audit",
    menucontent: "Ready to use Apps",
    Items: [
      { path: `${process.env.PUBLIC_URL}/admin/audit`, icon: "to-do", title: "Audit", type: "link" },
    ],
  },

  {
    menutitle: "General Settings",
    menucontent: "Ready to use Apps",
    Items: [
      { path: `${process.env.PUBLIC_URL}/admin/country/viewcountry`, icon: "internationalization", title: "Country", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/property/viewproperty`, icon: "others", title: "Property", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/category/viewcategory`, icon: "animation", title: "Category", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/subcategory/viewsubcategory`, icon: "blog", title: "Subcategory", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/tenant/viewtenant`, icon: "widget", title: "Tenants", type: "link" },
      ...(localStorage.getItem("accessLicenses") === "1" || localStorage.getItem("manageLicenses") === "1"
        ? [{ path: `${process.env.PUBLIC_URL}/admin/licenses`, icon: "to-do", title: "License Inventory", type: "link" }]
        : []),

    ],
  },

  {
    menutitle: "Configurations",
    menucontent: "Ready to use Apps",
    Items: [

      { path: `${process.env.PUBLIC_URL}/admin/configurations`, icon: "to-do", title: "Configurations", type: "link" },
    ],
  },


  {
    menutitle: "Admin Settings",
    menucontent: "Ready to use Apps",
    Items: [

      { path: `${process.env.PUBLIC_URL}/admin/userprofiles`, icon: "task", title: "User Profiles", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/users`, icon: "user", title: "Users", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/logs`, icon: "social", title: "Logs", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/schedulereports`, icon: "email", title: "Schedule Reports", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/tenantportal`, icon: "button", title: "Tenant Portal", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/healthcheckup`, icon: "builders", title: "Live Health Checkup", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/bulkimport`, icon: "file", title: "Bulk Import", type: "link" },
      { path: `${process.env.PUBLIC_URL}/admin/bulkimportlog`, icon: "file", title: "Bulk Import Log", type: "link" },
    ],
  },

  {
    menutitle: "",
    menucontent: "Ready to use Apps",
    Items: [


    ],
  },

];
